export default __webpack_public_path__ + "static/media/addButton.863e8b5c.svg";